import { useState } from 'react';

const faqs = [
  {
    q: 'What is Kakobuy Spreadsheet?',
    a: 'Kakobuy Spreadsheet is a structured product discovery database that organizes verified shopping finds into clean, searchable categories. It helps shoppers quickly find, compare, and save interesting products without endless browsing.',
  },
  {
    q: 'Is Kakobuy Spreadsheet free to use?',
    a: 'Yes, the Kakobuy Spreadsheet is completely free to browse and use. You can explore product categories, view organized finds, and access shopping guides at no cost. Visit the main website to start discovering products today.',
  },
  {
    q: 'How often is the Kakobuy Spreadsheet updated?',
    a: 'The Kakobuy Spreadsheet is updated on a daily basis with new verified product finds, trending items, and refreshed category data. The community actively contributes new discoveries to keep the database current and comprehensive.',
  },
  {
    q: 'Is Kakobuy safe for online shopping?',
    a: 'Absolutely. Kakobuy Spreadsheet includes verified product listings with quality checks and community reviews. However, always practice safe online shopping habits — verify sellers, check product details, and use secure payment methods.',
  },
  {
    q: 'What are the alternatives to Kakobuy Spreadsheet?',
    a: 'Popular alternatives include CSSBuy Spreadsheet, Superbuy Spreadsheet, and Oopbuy Spreadsheet. Each platform has unique features, but Kakobuy Spreadsheet stands out for its organized category system, daily updates, and user-friendly interface.',
  },
  {
    q: 'Can I contribute products to the Kakobuy Spreadsheet?',
    a: 'The Kakobuy Spreadsheet community welcomes contributions. Visit the main website at kaspreadsheet.com to learn how you can share your product discoveries with other shoppers and help the database grow.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3 text-center">
          Frequently Asked Questions
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          Everything you need to know about Kakobuy Spreadsheet
        </p>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-60 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}